// Global theme JS entry. Bundled into js/theme.bundle.js by jarvis2 build.
// Ported from the original FotoTK single-file index: sticky-nav state,
// scroll reveal, and the trailing cursor dot. (Loader + Tweaks panel are
// intentionally dropped — palette/font now come from the Customizer.)

document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('js-ready');

    // ── Sticky nav shadow on scroll ──────────────────────────────
    const nav = document.querySelector('[data-nav]');
    if (nav) {
        const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 40);
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    // ── Menu mobilne (fullscreen overlay) ────────────────────────
    const burger = document.querySelector('[data-nav-toggle]');
    const menu = document.getElementById('site-navigation');
    if (nav && burger && menu) {
        const label = burger.querySelector('[data-nav-toggle-label]');
        const OPEN = 'Zamknij menu';
        const CLOSED = 'Otwórz menu';

        const setMenu = (open) => {
            nav.classList.toggle('nav-open', open);
            document.body.classList.toggle('nav-open-lock', open);
            burger.setAttribute('aria-expanded', String(open));
            if (label) label.textContent = open ? OPEN : CLOSED;
        };
        const isOpen = () => burger.getAttribute('aria-expanded') === 'true';
        const close = () => setMenu(false);

        burger.addEventListener('click', () => setMenu(!isOpen()));

        // Klik w link zamyka overlay — kotwice (#kontakt) nie przeładowują
        // strony, więc bez tego menu zostałoby otwarte nad celem scrolla.
        menu.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', close);
        });

        // Accordion podmenu.
        menu.querySelectorAll('[data-submenu-toggle]').forEach((btn) => {
            btn.addEventListener('click', () => {
                const li = btn.closest('.menu-item-has-children');
                const expanded = btn.getAttribute('aria-expanded') === 'true';
                btn.setAttribute('aria-expanded', String(!expanded));
                if (li) li.classList.toggle('is-expanded', !expanded);
            });
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isOpen()) {
                close();
                burger.focus();
            }
        });

        // Powrót na desktop przy otwartym menu zostawiłby zablokowany scroll.
        const wide = window.matchMedia('(min-width: 901px)');
        const onWide = (e) => { if (e.matches) close(); };
        wide.addEventListener('change', onWide);
    }

    // ── Animacje wejścia na intersect ────────────────────────────
    // Dwa systemy obsługiwane jednocześnie:
    //   .reveal  → .in          (starsze szablony)
    //   .anim    → .is-visible   (biblioteka _anim.scss, wzór inspiration)
    const animated = document.querySelectorAll('.reveal, .anim');
    const activate = (el) => {
        el.classList.add('in');         // .reveal
        el.classList.add('is-visible'); // .anim
    };
    if (animated.length && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                if (e.isIntersecting) {
                    activate(e.target);
                    io.unobserve(e.target);
                }
            });
        }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
        animated.forEach((el) => io.observe(el));
    } else {
        animated.forEach(activate);
    }

    // ── Trailing cursor dot (pointer-fine devices only) ──────────
    const dot = document.getElementById('cursorDot');
    if (dot && window.matchMedia('(hover: hover)').matches) {
        let mx = window.innerWidth / 2, my = window.innerHeight / 2, dx = mx, dy = my;
        window.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; });
        (function tick() {
            dx += (mx - dx) * 0.18;
            dy += (my - dy) * 0.18;
            dot.style.transform = `translate(${dx}px, ${dy}px) translate(-50%, -50%)`;
            requestAnimationFrame(tick);
        })();
        document.querySelectorAll('a, button, .cat, .work-card, .service').forEach((el) => {
            el.addEventListener('mouseenter', () => { dot.style.width = dot.style.height = '32px'; });
            el.addEventListener('mouseleave', () => { dot.style.width = dot.style.height = '8px'; });
        });
    }
});
